export default __webpack_public_path__ + "static/media/model-s.b65171b9.jpg";